<template>
  <router-view />
</template>

<script>
  export default {
    name: 'AppAuth',
  };
</script>
